export default function (Alpine) {
    Alpine.data('jobPage', () => ({
        pageTitle: '',
        init() {
            // Set page title to the first h1 element within this.$el
            this.pageTitle = this.$el.querySelector('h1').innerText

            // Get <strong> elements within this.$el containing the page title and remove them
            let boldTags = this.$el.querySelectorAll('b')
            let filteredBoldTags = Array.from(boldTags).filter((b) => {
                return b.textContent.includes(this.pageTitle)
            })

            filteredBoldTags.forEach((b) => {
                let parent = b.parentElement
                if (parent.tagName === 'P') {
                    parent.remove()
                }
            })
        }
    }))
}
